<script setup lang="ts">
import { RouterView } from 'vue-router';
import Header from './components/HeaderComponent.vue';
import Footer from './components/FooterComponent.vue';
import { initializeEvents } from './entities/api/events';
import { onMounted, onUnmounted } from 'vue';
import debounce from './helpers/debounce';
import { useViewStore } from './stores/view.store';
import { initializeContacts } from './entities/api/contacts';
import { initializeTags } from './entities/api/tag';

const viewStore = useViewStore();

const getView = () => {
  const width = window.innerWidth;
  if (width <= 1024) {
    viewStore.setMobile();
  } else if (width <= 1600) {
    viewStore.setDesktop();
  } else {
    viewStore.setLarge();
  }
};

const debouncedViewUpdate = debounce(() => {
  getView();
}, 1000);

onMounted(async () => {
  getView();
  window.addEventListener('resize', debouncedViewUpdate);
});

onUnmounted(() => {
  window.removeEventListener('resize', debouncedViewUpdate);
});

initializeContacts();
initializeEvents();
initializeTags();
</script>

<template>
  <Header />
  <RouterView />
  <Footer />
</template>

<style scoped lang="scss"></style>
